import React from 'react';
import './blog-post.css';
import PM1 from './pictures/PM1.JPG';
import PM2 from './pictures/PM2.JPG';
import PM3 from './pictures/PM3.JPG';
import PM4 from './pictures/PM4.JPG';

//import reportWebVitals from './reportWebVitals';

const PMTalk = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Exploring Program Management Event Recap</h2>
                    <p className="site-post-meta">May 18th, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        On May 11th, WiC hosted our Exploring Program Management event to give WiC members the opportunity to learn about 
                        program management-related roles. Harini Gupta, Principal Group Program Manager for Microsoft Azure, gave a 
                        presentation about PM/TPM roles, her experience, and advice for those interested in program management. After the 
                        presentation, we had an engaging Q&A session. Thank you to everyone for attending and for asking such great 
                        questions! We appreciate your participation and we hope you found the event as informative and inspiring as we did.
                    </p>
                    <img src={PM1} alt="Women in Computing attendees and speaker"/>
                    <img src={PM2} alt="Women in Computing attendees and speaker"/>
                    <img src={PM3} alt="Women in Computing attendees and speaker"/>
                    <img src={PM4} alt="Women in Computing attendees and speaker"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default PMTalk;